const techs = [
  {
    name: 'AdonisJS',
    class: 'devicon-adonisjs-original colored',
    info: 'O AdonisJS é um framework robusto com diversas funcionalidades prontas baseado em outros grandes frameworks famosos como Laravel e Rails. Com ele fica fácil manipular a estrutura de dados do banco de dados relacional pois as vezes é necessário fazer alterações, adições ou exclusões de campos ou tabelas',
    link: 'https://adonisjs.com/',
  },
  {
    name: 'Android',
    class: 'devicon-android-plain colored',
    info: 'Android é um sistema operacional baseado no núcleo Linux, desenvolvido por um consórcio de desenvolvedores conhecido como Open Handset Alliance, sendo o principal colaborador o Google.',
    link: 'https://www.android.com/intl/pt-BR_br/',
  },
  {
    name: 'Angular',
    class: 'devicon-angularjs-plain colored',
    info: 'Angular é uma plataforma de aplicações web de código-fonte aberto e front-end baseado em TypeScript liderado pela Equipe Angular do Google e por uma comunidade de indivíduos e corporações. Angular é uma reescrita completa do AngularJS, feito pela mesma equipe que o construiu.',
    link: 'https://angular.io/',
  },
  {
    name: 'Apache',
    class: 'devicon-apache-plain colored',
    info: 'O Apache é um software de código aberto de propriedade da Apache Software Foundation (ASF) que garante desempenho, estabilidade e segurança para um servidor web. Ele se tornou muito popular entre os programadores devido à sua modularidade e ante atualização pela comunidade, o que contribui ativamente para a alta capacidade dessa ferramenta.',
    link: 'https://www.apache.org/',
  },
  {
    name: 'Apple',
    class: 'devicon-apple-original colored',
    info: 'Apple Inc. é uma empresa multinacional norte-americana que tem o objetivo de projetar e comercializar produtos eletrônicos de consumo, software de computador e computadores pessoais.',
    link: 'devicon-apple-original colored',
  },
  {
    name: 'Arduíno',
    class: 'devicon-arduino-plain colored',
    info: 'Arduíno é uma placa de prototipagem eletrônica de código aberto. O projeto, surgido na cidade de Ivrea, na Itália, em 2005, inclui hardware e software livre e visa oferecer ferramentas adaptáveis e de baixo custo para a criação de projetos interativos de diversas ordens.',
    link: 'https://www.arduino.cc/',
  },
  {
    name: 'Azure',
    class: 'devicon-azure-plain colored',
    info: 'Formada por uma série de ferramentas diferentes, o Azure é um serviço que permite a empresas e desenvolvedores adquirirem as capacidades de processamento e armazenamento dos datacenters da Microsoft para aplicação em seus negócios como alternativa ao modelo convencional.',
    link: 'https://azure.microsoft.com/pt-br/',
  },
  {
    name: 'Babel',
    class: 'devicon-babel-plain colored',
    info: 'Babel é um transcompilador de JavaScript gratuito e de código aberto usado principalmente para converter o código ECMAScript 2015+ em uma versão compatível com versões anteriores de JavaScript que pode ser executada por mecanismos JavaScript mais antigos.',
    link: 'https://babeljs.io/',
  },
  {
    name: 'Backbone.js',
    class: 'devicon-backbonejs-plain colored',
    info: 'Backbone.js é uma biblioteca JavaScript inspirada em uma interface JSON RESTful que oferece uma arquitetura MV* ou MVC: model–view-controller. Backbone é famoso por sua leveza e robustez e a sua única dependência é o Underscore.js, que por sua vez é dependente da biblioteca jQuery para interações com o DOM.',
    link: 'https://backbonejs.org/',
  },
  {
    name: 'Bitbucket',
    class: 'devicon-bitbucket-original colored',
    info: 'Bitbucket é um serviço de hospedagem de projetos controlados através do Mercurial, um sistema de controle de versões distribuído. É similar ao GitHub. Bitbucket têm um serviço grátis e um comercial. O serviço é escrito em Python.',
    link: 'https://bitbucket.org/',
  },
  {
    name: 'Bootstrap',
    class: 'devicon-bootstrap-plain colored',
    info: 'Bootstrap é um framework web com código-fonte aberto para desenvolvimento de componentes de interface e front-end para sites e aplicações web usando HTML, CSS e JavaScript, baseado em modelos de design para a tipografia, melhorando a experiência do usuário em um site amigável e responsivo.',
    link: 'https://getbootstrap.com/',
  },
  {
    name: 'Bulma',
    class: 'devicon-bulma-plain colored',
    info: 'O Bulma é um framework CSS que vem ganhando muita notoriedade por ser moderno, responsivo, gratuito e modular. Possui quase todas as características encontradas nos frameworks mais antigos (e famosos) como o Bootstrap, mas conta com a vantagem de que você só precisa incluir o que você for realmente usar. ',
    link: 'https://bulma.io/',
  },
  {
    name: 'Bower',
    class: 'devicon-bower-plain colored',
    info: 'O Bower é um grande gerenciador de pacotes geralmente utilizado para desenvolvimento de front-end para a Web, e pode ser dito que é a única solução de gerenciador de pacotes apenas para front-end.',
    link: 'https://bower.io/',
  },
  {
    name: 'C',
    class: 'devicon-c-plain colored',
    info: 'C é uma linguagem de programação compilada de propósito geral, estruturada, imperativa, procedural, padronizada pela Organização Internacional para Padronização, criada em 1972 por Dennis Ritchie na empresa AT&T Bell Labs para desenvolvimento do sistema operacional Unix. ',
    link: 'https://docs.microsoft.com/pt-br/cpp/c-language/?view=msvc-170',
  },
  {
    name: 'Chrome',
    class: 'devicon-chrome-plain colored',
    info: 'O Google Chrome é um navegador de internet, desenvolvido pela companhia Google com visual minimalista. Foi lançado pela primeira vez em setembro de 2008, para o Microsoft Windows, e mais tarde foi portado para Linux, Mac, iOS e Android.',
    link: 'https://www.google.com/intl/pt-BR/chrome/',
  },
  {
    name: 'CircleCI',
    class: 'devicon-circleci-plain colored',
    info: 'O CircleCI é uma ferramenta que permite que as equipes liberem rapidamente o código em que confiam, automatizando o processo de compilação, teste e entrega para aplicativos moveis e da web, na nuvem ou em um próprio servidor privado. Diversas empresas como Samsung, Ford Motor Company, Spotify, Lyft, Coinbase, PagerDuty, Stitch Fix e outras, contam com o CircleCI para acelerar a entrega e melhorar a qualidade.',
    link: 'https://circleci.com/',
  },
  {
    name: 'Clojure',
    class: 'devicon-clojure-line colored',
    info: 'Clojure é um dialeto da linguagem de programação Lisp criado por Rich Hickey. Clojure é uma linguagem de programação de propósito geral com ênfase em programação funcional. ',
    link: 'https://clojure.org/',
  },
  {
    name: 'ClojureScript',
    class: 'devicon-clojurescript-plain colored',
    info: 'Clojure é uma linguagem de programação dinâmica, de propósito geral com ênfase em programação funcional criada por Rich Hickey. Clojure roda sob a JVM (máquina virtual do Java), compila para bytecode como o Java faz, ainda existe a possibilidade de compilar para a CLR (plataforma .NET) e ClojureScript que compila para Javascript.',
    link: 'https://clojurescript.org/',
  },
  {
    name: 'CodeIgniter',
    class: 'devicon-codeigniter-plain colored',
    info: 'O Codelgniter é um poderoso framework PHP dentre diversos outros já existentes. Criado para desenvolvedores que precisam de um conjunto de ferramentas simples para a criação de aplicativos web completos, o CodeIgniter é uma excelente alternativa para o desenvolvimento de projetos utilizando o PHP.',
    link: 'https://codeigniter.com/',
  },
  {
    name: 'CodePen',
    class: 'devicon-codepen-plain colored',
    info: 'O CodePen é uma comunidade on-line para testar e mostrar trechos de código HTML, CSS e JavaScript criados pelo usuário. Ele funciona como um editor de código on-line e um ambiente de aprendizado de código aberto, onde os desenvolvedores podem criar trechos de código, chamados "canetas", e testá-los.',
    link: 'https://codepen.io/',
  },
  {
    name: 'CoffeeScript',
    class: 'devicon-coffeescript-original colored',
    info: 'CoffeeScript é uma linguagem de programação que transcompila para JavaScript. A linguagem adiciona elementos de sintaxe inspirados no Ruby, Python e Haskell para aprimorar a leitura e concisão do JavaScript, adicionando características sofisticadas como compreensão de lista e Casamento de padrões.',
    link: 'https://coffeescript.org/',
  },
  {
    name: 'Composer',
    class: 'devicon-composer-line colored',
    info: 'O Composer é um gerenciador de pacotes no nível do aplicativo para a linguagem de programação PHP que fornece um formato padrão para gerenciar dependências do software PHP e bibliotecas necessárias. Foi desenvolvido por Nils Adermann e Jordi Boggiano, que continuam a gerenciar o projeto.',
    link: 'https://getcomposer.org/',
  },
  {
    name: 'Confluence',
    class: 'devicon-confluence-original colored',
    info: 'O Confluence é um wiki corporativo (software de documentação colaborativa ) baseado na web desenvolvido pela empresa de software australiana Atlassian. Atlassian escreveu o Confluence na linguagem de programação Java e o publicou pela primeira vez em 2004.',
    link: 'https://www.atlassian.com/br/software/confluence',
  },
  {
    name: 'CouchDB',
    class: 'devicon-couchdb-plain colored',
    info: 'Apache CouchDB, comumente referido como CouchDB, é um banco de dados de código-aberto que foca na facilidade de uso e na filosofia de ser "um banco de dados que abrange a Web',
    link: 'https://couchdb.apache.org/',
  },
  {
    name: 'C++',
    class: 'devicon-cplusplus-plain colored',
    info: 'C++ é uma linguagem de programação compilada multi-paradigma e de uso geral. Desde os anos 1990 é uma das linguagens comerciais mais populares, sendo bastante usada também na academia por seu grande desempenho e base de utilizadores.',
    link: 'https://www.cplusplus.com/',
  },
  {
    name: 'C#',
    class: 'devicon-csharp-plain colored',
    info: 'C# é uma linguagem de programação, multiparadigma, de tipagem forte, desenvolvida pela Microsoft como parte da plataforma .NET. A sua sintaxe orientada a objetos foi baseada no C++ mas inclui muitas influências de outras linguagens de programação, como Object Pascal e, principalmente, Java. ',
    link: 'https://docs.microsoft.com/pt-br/dotnet/csharp/',
  },
  {
    name: 'CSS - Cascading Style Sheets',
    class: 'devicon-css3-plain colored',
    info: 'CSS - Cascading Style Sheets é um mecanismo para adicionar estilo a um documento web. O código pode ser aplicado diretamente nas tags ou ficar contido dentro das tags <style>. Também é possível, em vez de colocar a formatação dentro do documento, criar um link para um arquivo que contém os estilos.',
    link: 'https://developer.mozilla.org/pt-BR/docs/Web/CSS',
  },
  {
    name: 'Cucumber',
    class: 'devicon-cucumber-plain colored',
    info: 'Cucumber é usado para descrever o valor do negócio em uma linguagem natural, por isso permite que equipes de desenvolvimento de software descrevam como o software deve se comportar em texto simples, escrevendo especificações através de exemplos.',
    link: 'https://cucumber.io/',
  },
  {
    name: 'Crystal',
    class: 'devicon-crystal-original colored',
    info: 'Crystal é uma linguagem de programação multiparadigma compilada de tipagem estática e sintaxe fortemente inspirada em Ruby, e em C#, Go, Python e Rust, criada por Ary Borenszweig. ',
    link: 'https://crystal-lang.org/',
  },
  {
    name: 'D3.js',
    class: 'devicon-d3js-plain colored',
    info: 'D3.js é uma biblioteca JavaScript para produzir visualizações de dados interativas e dinâmicas em navegadores da web. Ele usa os padrões Scalable Vector Graphics, HTML5 e Cascading Style Sheets. É o sucessor da estrutura anterior do Protovis.',
    link: 'https://d3js.org/',
  },
  {
    name: 'Dart',
    class: 'devicon-dart-plain colored',
    info: 'Dart é uma linguagem de script voltada à web desenvolvida pela Google. Ela foi lançada na GOTO Conference 2011, que aconteceu de 10 a 11 de outubro de 2011 em Aarhus, na Dinamarca. O objetivo da linguagem Dart foi inicialmente a de substituir a JavaScript como a linguagem principal embutida nos navegadores.',
    link: 'https://dart.dev/',
  },
  {
    name: 'Debian',
    class: 'devicon-debian-plain colored',
    info: 'Debian, anteriormente chamado Debian GNU/Linux e hoje apenas Debian, é um sistema operacional composto inteiramente de software livre e mantido oficialmente pelo Projeto Debian. O projeto recebe, ainda, apoio de outros indivíduos e organizações de todo o mundo.',
    link: 'https://www.debian.org/index.pt.html',
  },
  {
    name: 'Deno',
    class: 'devicon-denojs-original colored',
    info: 'O Deno é um ambiente de execução para JavaScript e TypeScript baseado no mecanismo JavaScript V8 e na linguagem de programação Rust. Foi criado por Ryan Dahl, criador original do Node.js, e é focado na produtividade. Foi anunciado por Dahl em 2018 durante sua palestra "10 coisas que lamento pelo Node.js".',
    link: 'https://deno.land/',
  },
  {
    name: 'Django',
    class: 'devicon-django-plain colored',
    info: 'Django é um framework para desenvolvimento rápido para web, escrito em Python, que utiliza o padrão model-template-view. Foi criado originalmente como sistema para gerenciar um site jornalístico na cidade de Lawrence, no Kansas. Tornou-se um projeto de código aberto e foi publicado sob a licença BSD em 2005.',
    link: 'https://www.djangoproject.com/',
  },
  {
    name: 'Docker',
    class: 'devicon-docker-plain colored',
    info: 'Docker é um conjunto de produtos de plataforma como serviço que usam virtualização de nível de sistema operacional para entregar software em pacotes chamados contêineres. Os contêineres são isolados uns dos outros e agrupam seus próprios softwares, bibliotecas e arquivos de configuração.',
    link: 'https://www.docker.com/',
  },
  {
    name: 'Doctrine',
    class: 'devicon-doctrine-plain colored',
    info: 'O Doctrine Project é um conjunto de bibliotecas PHP focadas principalmente em fornecer serviços de persistência e funcionalidades relacionadas. Seus projetos premiados são um mapeador relacional de objetos e a camada de abstração do banco de dados sobre a qual é construído.',
    link: 'https://www.doctrine-project.org/',
  },
  {
    name: '.NET Framework',
    class: 'devicon-dot-net-plain colored',
    info: 'O .NET Framework é uma iniciativa da empresa Microsoft, que visa uma plataforma única para desenvolvimento e execução de sistemas e aplicações. Todo e qualquer código gerado para .NET Framework pode ser executado em qualquer dispositivo que possua um framework de tal plataforma.',
    link: 'https://dotnet.microsoft.com/apps/aspnet',
  },
  {
    name: '.NET CORE',
    class: 'devicon-dotnetcore-plain colored',
    info: '.NET é um framework livre e de código aberto para os sistemas operacionais Windows, Linux e macOS. É um sucessor de código aberto de sua versão anterior. O projeto é desenvolvido principalmente pela Microsoft e lançado com a Licença MIT. ',
    link: 'https://dotnet.microsoft.com/download',
  },
  {
    name: 'Drupal',
    class: 'devicon-drupal-plain colored',
    info: 'Drupal é um framework modular e um sistema de gestão de conteúdos escrito em PHP. O Drupal permite criar e organizar conteúdo, manipular a aparência, automatizar tarefas administrativas e definir permissões e papéis para usuários e colaboradores. ',
    link: 'https://www.drupal.org/',
  },
  {
    name: 'DigitalOcean',
    class: 'devicon-digitalocean-plain colored',
    info: 'DigitalOcean, Inc. é um provedor americano de infraestrutura em nuvem com sede na cidade de Nova York e centros de dados em todo o mundo. A DigitalOcean fornece aos desenvolvedores serviços em nuvem que ajudam a implantar e dimensionar aplicativos que são executados simultaneamente em vários computadores.',
    link: 'https://www.digitalocean.com/',
  },
  {
    name: 'Electron',
    class: 'devicon-electron-original colored',
    info: 'Electron é um framework de código aberto criado por Cheng Zhao, e agora desenvolvido pelo GitHub. Ele permite desenvolver aplicações para desktop GUI usando componentes front end e back end originalmente criados para aplicações web: Node.js para o back end e Chromium para o front end.',
    link: 'https://www.electronjs.org/',
  },
  {
    name: 'Eleventy',
    class: 'devicon-eleventy-plain colored',
    info: 'Eleventy é um gerador de sites estáticos escrito em JavaScript. O Eleventy pega suas páginas (escritas em um dos muitos mecanismos de modelagem que ele suporta) e as converte em HTML durante o processo de construção.',
    link: 'https://www.11ty.dev/',
  },
  {
    name: 'Elixir',
    class: 'devicon-elixir-plain colored',
    info: 'Elixir trata-se de uma linguagem com código aberto que é executada  na Máquina Virtual Erlang (Erlang VM), cujo principal objetivo é oferecer uma programação produtiva para aplicações distribuídas seguras e de fácil manutenção, potencializando os recursos da máquina virtual sobre a qual está fundada sem custos de performance.',
    link: 'https://elixir-lang.org/',
  },
  {
    name: 'Elm',
    class: 'devicon-elm-plain colored',
    info: 'Elm é uma linguagem de programação específica de domínio para criar declarativamente interfaces gráficas com o usuário baseadas em navegador da web. Elm é puramente funcional e é desenvolvido com ênfase em usabilidade, desempenho e robustez.',
    link: 'https://elm-lang.org/',
  },
  {
    name: 'Ember.js',
    class: 'devicon-ember-original-wordmark colored',
    info: 'Ember.js é um framework web JavaScript de código aberto, baseado na arquitetura Model–view–viewmodel. Ele permite aos desenvolvedores aplicativos web de página única escaláveis, ao incorporar expressões idiomáticas comuns e boas práticas de desenvolvimento em seu núcleo.',
    link: 'https://emberjs.com/',
  },
  {
    name: 'Erlang',
    class: 'devicon-erlang-plain colored',
    info: 'Erlang é uma linguagem de programação de uso geral e um sistema para execução. Foi desenvolvida pela Ericsson para suportar aplicações distribuídas e tolerantes a falhas a serem executadas em um ambiente de tempo real e ininterrupto.',
    link: 'https://www.erlang.org/',
  },
  {
    name: 'Express.js',
    class: 'devicon-express-original colored',
    info: 'Express.js é um framework para Node.js que fornece recursos mínimos para construção de servidores web. Foi lançado como software livre e de código aberto sob a Licença MIT. É um dos mais populares frameworks para servidores em Node.js.',
    link: 'https://expressjs.com/pt-br/',
  },
  {
    name: 'FeatherJS',
    class: 'devicon-feathersjs-original colored',
    info: 'FeathersJS é uma estrutura de micro-serviço e tempo real amplamente usada para NodeJS. Ele foi projetado com recursos para simplificar o desenvolvimento de aplicativos da web modernos e aplicativos móveis. O FeathersJS permite que os desenvolvedores controlem os dados por meio de recursos e soquetes RESTful.',
    link: 'https://feathersjs.com/',
  },
  {
    name: 'FileZilla',
    class: 'devicon-filezilla-plain colored',
    info: 'FileZilla é um cliente FTP, SFTP e FTPS de código livre para Microsoft Windows e GNU/Linux. É distribuído em licença GNU General Public License. Desde 1 de março de 2007 ocupa a 9ª posição na lista dos mais baixados do SourceForge, desbancando nomes como phpBB, Pidgin e MinGW.',
    link: 'https://filezilla-project.org/',
  },
  {
    name: 'Firebase',
    class: 'devicon-firebase-plain colored',
    info: 'Firebase é uma plataforma desenvolvida pelo Google para a criação de aplicativos móveis e da web. Era originalmente uma empresa independente fundada em 2011. Em 2014, o Google adquiriu a plataforma e agora é sua oferta principal para o desenvolvimento de aplicativos.',
    link: 'https://firebase.google.com/?hl=pt',
  },
  {
    name: 'Mozilla Firefox',
    class: 'devicon-firefox-plain colored',
    info: 'Mozilla Firefox é um navegador livre e multiplataforma desenvolvido com ajuda de centenas de colaboradores. A intenção da fundação é desenvolver um navegador leve, seguro, intuitivo e altamente extensível.',
    link: 'https://www.mozilla.org/pt-BR/',
  },
  {
    name: 'Flask',
    class: 'devicon-flask-original colored',
    info: 'Flask é um pequeno framework web escrito em Python. É classificado como um microframework porque não requer ferramentas ou bibliotecas particulares, mantendo um núcleo simples, porém, extensível.',
    link: 'https://flask.palletsprojects.com/en/2.0.x/',
  },
  {
    name: 'Flutter',
    class: 'devicon-flutter-plain colored',
    info: 'Flutter é um kit de desenvolvimento de interface de usuário, de código aberto, criado pelo Google, que possibilita a criação de aplicativos compilados nativamente. Atualmente pode compilar para Android, iOS, Windows, Mac, Linux, Google Fuchsia e Web.',
    link: 'https://flutter.dev/',
  },
  {
    name: 'F#',
    class: 'devicon-fsharp-plain colored',
    info: 'F# é uma linguagem de programação multiparadigma para a plataforma .NET, que engloba programação funcional, imperativa e orientada a objetos. Pertence à família das linguagens ML, e é em grande parte compatível com a linguagem OCaml.',
    link: 'https://fsharp.org/',
  },
  {
    name: 'Gatling',
    class: 'devicon-gatling-plain colored',
    info: 'Gatling é uma estrutura de teste de desempenho e carga de código aberto baseada em Scala, Akka e Netty. A primeira versão estável foi publicada em 13 de janeiro de 2012. Em 2015, o fundador da Gatling, Stéphane Landelle, criou uma empresa dedicada ao desenvolvimento do projeto de código aberto. ',
    link: 'https://gatling.io/',
  },
  {
    name: 'Gatsby',
    class: 'devicon-gatsby-plain colored',
    info: 'Gatsby é uma framework escrita em JavaScript e React, cuja proposta é ajudar desenvolvedores a construir aplicações e websites de forma facilitada. O foco do Gatsby é proporcionar um desenvolvimento rápido, efetivo e performático, acima de tudo.',
    link: 'https://www.gatsbyjs.com/',
  },
  {
    name: 'GCC - GNU Compiler Collection',
    class: 'devicon-gcc-plain colored',
    info: 'O GCC - GNU Compiler Collection é um conjunto de compiladores de linguagens de programação produzido para construir um sistema operativo semelhante ao Unix livre.',
    link: 'https://gcc.gnu.org/',
  },
  {
    name: 'GIMP',
    class: 'devicon-gimp-plain colored',
    info: 'GIMP é um programa de código aberto voltado principalmente para criação e edição de imagens raster, e em menor escala também para desenho vetorial. ',
    link: 'https://www.gimp.org/',
  },
  {
    name: 'Git',
    class: 'devicon-git-plain colored',
    info: 'Git é um sistema de controle de versões distribuído, usado principalmente no desenvolvimento de software, mas pode ser usado para registrar o histórico de edições de qualquer tipo de arquivo.',
    link: 'https://git-scm.com/',
  },
  {
    name: 'GitHub',
    class: 'devicon-github-original colored',
    info: 'GitHub é uma plataforma de hospedagem de código-fonte e arquivos com controle de versão usando o Git. Ele permite que programadores, utilitários ou qualquer usuário cadastrado na plataforma contribuam em projetos privados e/ou Open Source de qualquer lugar do mundo.',
    link: 'https://github.com/',
  },
  {
    name: 'GitLab',
    class: 'devicon-gitlab-plain colored',
    info: 'O GitLab é um gerenciador de repositório de software baseado em git, com suporte a Wiki, gerenciamento de tarefas e CI/CD. GitLab é similar ao GitHub, mas o GitLab permite que os desenvolvedores armazenem o código em seus próprios servidores, ao invés de servidores de terceiros.',
    link: 'https://about.gitlab.com/',
  },
  {
    name: 'Gitter',
    class: 'devicon-gitter-plain colored',
    info: 'Gitter é um sistema de mensagem instantânea e sala de bate-papo de código aberto para desenvolvedores e usuários de repositórios GitLab e GitHub. ',
    link: 'https://gitter.im/',
  },
  {
    name: 'Go',
    class: 'devicon-go-original-wordmark colored',
    info: 'Go é uma linguagem de programação criada pela Google e lançada em código livre em novembro de 2009. É uma linguagem compilada e focada em produtividade e programação concorrente, baseada em trabalhos feitos no sistema operacional chamado Inferno.',
    link: 'https://golang.org/',
  },
  {
    name: 'Google',
    class: 'devicon-google-plain colored',
    info: 'Google LLC é uma empresa multinacional de serviços online e software dos Estados Unidos. O Google hospeda e desenvolve uma série de serviços e produtos baseados na internet e gera lucro principalmente através da publicidade pelo AdWords. A Google é a principal subsidiária da Alphabet Inc.',
    link: 'https://www.google.com.br/',
  },
  {
    name: 'Google Cloud Platform',
    class: 'devicon-googlecloud-plain colored',
    info: 'Google Cloud Platform é uma suíte de computação em nuvem oferecida pelo Google, funcionando na mesma infraestrutura que a empresa usa para seus produtos dirigidos aos usuários, dentre eles o Buscador Google e o Youtube. ',
    link: 'https://cloud.google.com/',
  },
  {
    name: 'Gradle',
    class: 'devicon-gradle-plain colored',
    info: 'Gradle é um sistema de automação de compilação de código aberto que se baseia nos conceitos de Apache Ant e Apache Maven e introduz uma linguagem de domínio específico baseada em Groovy em vez do XML usado pelo Apache Maven para declarar a configuração do projeto.',
    link: 'https://gradle.org/',
  },
  {
    name: 'Grails',
    class: 'devicon-grails-plain colored',
    info: 'Grails é um framework para construção de aplicações para web através da linguagem de programação Groovy. Foi desenvolvido em código aberto e pretende ser um framework de alta produtividade graças à utilização do paradigma da programação por convenção que preserva o desenvolvedor dos detalhes de configuração. ',
    link: 'https://grails.org/',
  },
  {
    name: '',
    class: '',
    info: '',
    link: '',
  },
];

export default techs;

/* name: '',
  info: '',
  link: '', */
